import { render } from "./FootComponent.vue?vue&type=template&id=3b11adb0"
import script from "./FootComponent.vue?vue&type=script&lang=js"
export * from "./FootComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__